var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [
      _vm._v(_vm._s(_vm.$t("Shortlist Used")) + "\n    "),
      _vm.editing
        ? _c(
            "a",
            {
              staticClass: "btn btn-sm pull-right",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#modal-add-talent",
                "data-backdrop": "static",
              },
            },
            [
              _c("i", { staticClass: "fa fa-plus" }),
              _vm._v(" "),
              [
                _vm._v(
                  "Add " + _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                ),
              ],
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortlist-backing-admin" }, [
      _vm.bookingHasNoShortlistedTalent
        ? _c("div", { staticClass: "p-sm text-center" }, [
            _vm._v(
              "\n      There are no " +
                _vm._s(_vm.$t("shortlisted stars")) +
                ".\n    "
            ),
          ])
        : _c(
            "div",
            { staticClass: "shortlist row" },
            _vm._l(_vm.bookingShortlistedTalent, function (user) {
              return _c("booking-search-details-list-item-admin", {
                key: user.id,
                attrs: { user: user },
              })
            }),
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }